import type { TourStepData } from './types';

export const marketingDashboardTourSteps: TourStepData[] = [
  {
    target: '[data-tour="marketing-dashboard-header"]',
    title: 'Marketing Dashboard',
    content:
      'Le Marketing Dashboard (Tableau de bord marketing) centralise les performances de vos contenus, le pipeline de prospection et le reseau de parrainage.',
    placement: 'bottom',
  },
  {
    target: '.grid.grid-cols-1.sm\\:grid-cols-2.lg\\:grid-cols-4',
    title: 'KPIs Marketing',
    content:
      'Suivez les indicateurs cles : contenus generes, performances de campagnes, prospects en cours et taux de conversion du parrainage.',
    placement: 'bottom',
    glossaryTerm: 'kpi',
  },
  {
    target: '.lg\\:col-span-2',
    title: 'Content Performance',
    content:
      'Le graphique de performance des contenus montre l\'evolution de vos publications et leur impact au fil du temps.',
    placement: 'bottom',
  },
];
